export const CULTURAS = {
    SOJA: {
        nome: 'Soja',
        codigo: 'SOJA',
        cor: '#9CCC65'
    },
    MILHO: {
        nome: 'Milho',
        codigo: 'MILHO',
        cor: '#FFEE58'
    },
    ALGODAO: {
        nome: 'Algodão',
        codigo: 'ALGODAO',
        cor: '#FFFFFF'
    },
    OUTROS: {
        nome: 'Outros',
        codigo: 'OUTROS',
        cor: '#DC610D'
    },
    NAO_IDENTIFICADA: {
        nome: 'Não identificada',
        codigo: 'NAO_IDENTIFICADA',
        cor: '#BBBBBB'
    },
    MAIOR_80: {
        nome: 'Soja',
        codigo: 'SOJA',
        cor: '#63AF01'
    },
    DE_51_A_80: {
        nome: 'Soja',
        codigo: 'SOJA',
        cor: '#889306'
    },
    MENOR_50: {
        nome: 'Soja',
        codigo: 'SOJA',
        cor: '#D6D951'
    }
};
